<template>
	<div class="m-l-50 m-t-30 w-500">
		<el-form ref="form" :model="form" :rules="rules" label-width="130px">
			<el-form-item label="用户名" prop="username">
				<el-input v-model.trim="form.username" class="h-40 w-200" :maxlength="32"></el-input>
			</el-form-item>
			<el-form-item label="密码" prop="password">
				<el-input v-model.trim="form.password" class="h-40 w-200"></el-input>
			</el-form-item>
			<el-form-item label="真实姓名" prop="realname">
				<el-input v-model.trim="form.realname" class="h-40 w-200"></el-input>
			</el-form-item>
			<el-form-item label="部门" prop="structure_id">
				<el-select v-model="form.structure_id" multiple placeholder="请选择部门" class="w-200">
					<el-option v-for="item in orgsOptions" :label="item.title" :value="item.id"></el-option>
				</el-select>
			</el-form-item>
      <el-form-item label="职位" prop="position">
        <el-input v-model.trim="form.position" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="手机号码" prop="mobile">
        <el-input v-model.trim="form.mobile" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="邮箱" prop="email">
        <el-input v-model.trim="form.email" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="微信号" prop="weixin_id">
        <el-input v-model.trim="form.weixin_id" class="h-40 w-200"></el-input>
      </el-form-item>
      <el-form-item label="座机" prop="telephone">
        <el-input v-model.trim="form.telephone" class="h-40 w-200"></el-input>
      </el-form-item>
			<el-form-item label="备注">
				<el-input v-model.trim="form.remark" class="h-40 w-200"></el-input>
			</el-form-item>
      <el-form-item label="上级" prop="leader">
        <el-select v-model="form.leader" filterable placeholder="请选择上级" class="w-200">
          <el-option v-for="item in users" :label="item.realname" :value="item.id"></el-option>
        </el-select>
      </el-form-item>
			<el-form-item label="用户组">
				<el-checkbox-group v-model="selectedGroups">
					<el-checkbox v-for="item in groupOptions" :label="item.title" class="form-checkbox"></el-checkbox>
				</el-checkbox-group>
			</el-form-item>
			<el-form-item>
				<el-button type="primary" @click="add()" :loading="isLoading">提交</el-button>
				<el-button @click="goback()">返回</el-button>
			</el-form-item>
		</el-form>
	</div>
</template>
<style type="text/css">
	.form-checkbox:first-child{
		margin-left: 15px;
	}
</style>
<script>
  import http from '../../../../assets/js/http'
  import _verify from '../../../../assets/js/verify'

  export default {
    data() {
      return {
        isLoading: false,
        form: {
          username: '',
          password: '',
          realname: '',
          structure_id: [],
          post_id: null,
          remark: '',
          groups: [],
          position: '',
          mobile: '',
          email: '',
          weixin_id: '',
          telephone: '',
          leader: ''
        },
        pos: [],
        orgsOptions: [],
        groupOptions: [],
        selectedGroups: [],
        selectedIds: [],
        rules: {
          username: [
            { required: true, message: '请输入用户名' }
          ],
          password: [
            { required: true, message: '请输入用户密码' }
          ],
          realname: [
            { required: true, message: '请输入真实姓名' }
          ],
          structure_id: [
            { required: true, message: '请选择用户部门' }
          ],
          position: [
            { required: true, message: '请选择用户职位' }
          ],
          email: [
            { type: 'email', message: '请输入正确的邮箱地址', trigger: 'blur' }
          ],
          mobile: [
            { validator: this.isPhone, trigger: 'blur' }
          ],
          weixin_id: [
            { validator: this.isEngAndNum, trigger: 'blur' }
          ]
        },
        users: []
      }
    },
    methods: {
      selectCheckbox() {
        let temp = false
        _(this.selectedGroups).forEach((res1) => {
          _(this.groupOptions).forEach((res2) => {
            if (res1 == res2.title) {
              this.selectedIds.push(res2.id)
            }
          })
        })
        if (this.selectedIds.length) {
          this.form.groups = this.selectedIds
          temp = true
        }
        this.selectedIds = []
        return temp
      },
      add() {
        if (!this.selectCheckbox()) {
          _g.toastMsg(this, 'warning', '请选择用户组')
          return
        }
        console.log('res = ', _g.j2s(this.form))
        this.$refs.form.validate((pass) => {
          if (pass) {
            this.isLoading = !this.isLoading
            this.apiPost('admin/users', this.form).then((res) => {
              if (res.code == 200) {
                _g.toastMsg(this, 'success', '添加成功')
                _g.clearVuex('setUsers')
                setTimeout(() => {
                  this.goback()
                }, 1500)
              } else {
                this.isLoading = !this.isLoading
                _g.dealError(this, res)
              }
            })
          }
        })
      },
      goback() {
        router.go(-1)
      },
      getAllGroups() {
        this.apiGet('admin/groups').then((res) => {
          if (res.code == 200) {
            this.groupOptions = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      // getAllPos() {
      //   this.apiGet('admin/posts').then((res) => {
      //     if (res.code == 200) {
      //       this.pos = res.data
      //     } else {
      //       _g.dealError(this, res)
      //     }
      //   })
      // },
      getAllOrgs() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/structures', postData).then((res) => {
          if (res.code == 200) {
            this.orgsOptions = res.data
          } else {
            _g.dealError(this, res)
          }
        })
      },
      getAllUsers() {
        let postData = {
          params: {
            status: 1
          }
        }
        this.apiGet('admin/users', postData).then((res) => {
          if (res.code == 200) {
            this.users = res.data.list
          } else {
            _g.dealError(this, res)
          }
        })
      },
      isPhone(rule, value, callback) {
        if (!_verify.isPhone(value)) {
          callback(new Error('请输入正确的手机号码'))
        } else {
          callback()
        }
      },
      isEngAndNum(rule, value, callback) {
        if (!_verify.isEngAndNum(value)) {
          callback(new Error('请输入正确的微信号'))
        } else {
          callback()
        }
      }
    },
    created() {
      this.getAllGroups()
      this.getAllOrgs()
      // this.getAllPos()
      this.getAllUsers()
    },
    components: {

    },
    mixins: [http]
  }
</script>


// WEBPACK FOOTER //
// add.vue?2cdbf85c